<template>
    <div class="share-watchlist-type-option-all share-watchlist-type-option" :class="{ disabled: isSelectedWatchListSharedToSelectedUsers }">
        <div class="share-watchlist-type-option__text-container">
            <p class="share-watchlist-type-option__paragraph">
                <span class="icon-users share-watchlist-type-option__icon"></span>
                <span v-html="$t('WatchListModal.share_watchlist_type_option_share_all')"></span>
            </p>
            <span class="share-watchlist-type-option__info" v-html="$t('WatchListModal.share_watchlist_type_paragraph_info')"></span>
        </div>
        <template v-if="isSelectedWatchListSharedToAllSubordinates">
            <div class="share-watchlist-type-option__button">
                <TotemButton size="small" color="primary" @click="removeSharingWithAllSubordinates" :label="$t('WatchListModal.share_watchlist_type_option_remove_sharing')" />
            </div>
        </template>
        <template v-else>
            <div class="share-watchlist-type-option__button">
                <TotemButton
                    :disabled="isSelectedWatchListSharedToSelectedUsers"
                    size="small"
                    color="primary"
                    @click="shareWithAllSubordinates"
                    :label="$t('WatchListModal.share_watchlist_type_option_share_all_button')"
                />
            </div>
        </template>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import shareWatchListHelper from 'components/shared/mixins/shareWatchListHelper'

    export default {
        name: 'ShareWatchListTypeOptionAll',
        mixins: [ shareWatchListHelper ],
        computed: {
            ...mapGetters({
                watchLists: 'Watchlists/getWatchLists',
                selectedWatchList: 'Watchlists/getSelectedWatchList'
            })
        },
        methods: {
            shareWithAllSubordinates () {
                this.$emit('shareWithAllSubordinates')
            },
            removeSharingWithAllSubordinates () {
                this.$emit('removeSharingWithAllSubordinates')
            }
        }
    }
</script>

<style lang="scss" scoped>
    @include share_watchlist_type_button;

    .share-watchlist-type-option-all {

        &__type-button-container-remove-sharing {
            padding: 15px;
            display: flex;
            justify-content: center;
            background-color: $lavender;
            border-radius: 0 0 16px 16px;
        }
    }

</style>
